import dynamic from 'next/dynamic';
import { useTranslation } from '../../lib/i18n';
import { Container } from '../layout/container';
import Detail from '../product/detail';
import { DefaultTitle } from '../product/hero';
import Included from '../product/included';
import EventMeta from './meta';

const DynamicAddToCart = dynamic(() => import('../cart/add-to-cart'));
const DynamicProductImageCarousel = dynamic(
  () => import('../product/product-image-carousel'),
);

const Title = ({ product, className = '' }) => (
  <div className={`${className} text-center lg:text-left`}>
    <DefaultTitle product={product} />
    <EventMeta event={product} className='ml-0 mt-4' />
  </div>
);

const EventDetail = ({ product, related, preview }) => {
  const { t, attrT } = useTranslation();
  const lead = attrT(product.metadata, 'lead');
  const description = attrT(product, 'description');

  return (
    <Detail
      preview={preview}
      product={product}
      related={related}
      heroTitle={Title}
      relatedTitle={t('homeEvents')}
      relatedText={t('homeEventsText')}
      relatedBtnLink={`/events`}
      relatedBtnText={t('homeEventsButton')}
      section='event'
      bgColor={product.metadata?.['bg-color']}
      titleColor={product.metadata?.['fg-color']}
    >
      <Container className='pb-12'>
        <div className='gap-2 lg:grid lg:grid-cols-12'>
          <DynamicAddToCart
            compact={false}
            product={product}
            className='col-span-4 col-start-9 mx-auto mb-6 w-full lg:order-last lg:mb-0'
          />

          <div className='col-span-7'>
            {lead && <p className='mb-6 font-bold uppercase'>{lead}</p>}

            {description && (
              <div
                className='cmsRichText mb-10'
                dangerouslySetInnerHTML={{
                  __html: description,
                }}
              />
            )}
          </div>
        </div>
        <Included product={product} />
        {product.images && <DynamicProductImageCarousel className='mt-14' />}
      </Container>
    </Detail>
  );
};

export default EventDetail;
